// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/js/" + chunkId + "." + {"239":"871ed923","389":"6fdddd8a","732":"b9378afb","879":"4e00e68e"}[chunkId] + ".chunk.js");